import type { SpotGridZoomViewportLazyProps } from './SpotGridZoomViewportLazy.types';

/** Web/UMD: pinch is native-only; passthrough keeps gesture-handler/reanimated out of the bundle. */
export default function SpotGridZoomViewportLazy({ children }: SpotGridZoomViewportLazyProps) {
  return <>{children}</>;
}

export type { SpotGridZoomViewportLazyProps } from './SpotGridZoomViewportLazy.types';
